module.exports = __webpack_public_path__ + "static/img/open_eyes.14c3faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/open_eyes.png
// module id = HAyX
// module chunks = 1